// @flow

import React from "react";
import { localize } from "redux-i18n";
import { formatDateTime } from "@transformers/date";
import actionCreators from "@modules/client/actionCreator";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, GSGrid } from "@components";
import type { MiLogs } from "@modules/reporting/reducer/reports/mi-reports/types";

type OwnProps = $Exact<{
  clientId: number,
  toggleMiLogModal: Function,
  logs: Array<MiLogs>,
  data: Object,
  getLogs: Object => any,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export class MiLogModal extends React.Component<Props> {
  componentDidMount() {
    const { getLogs, data, clientId } = this.props;

    if (data.report && clientId) {
      getLogs({
        clientId,
        report: data.report,
      });
    }
  }

  get columns() {
    return [
      {
        key: "id",
        name: <span className="text-color-dark-grey">{this.props.t("ID")}</span>,
        renderCell: ({ row }: { row: MiLogs }) => row.sharedWith.id,
      },
      {
        key: "dateShared",
        width: 150,
        name: <span className="text-color-dark-grey">{this.props.t("DATE_SHARED")}</span>,
        renderCell: ({ row }: { row: MiLogs }) => formatDateTime(row.sharedAt),
      },
      {
        key: "sharedWith",
        align: "left",
        name: <span className="text-color-dark-grey">{this.props.t("SHARED_WITH")}</span>,
        renderCell: ({ row }: { row: MiLogs }) =>
          `${row.sharedWith.firstName} ${row.sharedWith.lastName}`,
      },
      {
        key: "downloaded",
        name: <span className="text-color-dark-grey">{this.props.t("IS_DOWNLOADED")}</span>,
        renderCell: ({ row }: { row: MiLogs }) =>
          row.status === "YES" ? (
            <span className="text-color-positive">{this.props.t("YES")}</span>
          ) : (
            <span className="text-color-negative">{this.props.t("NO")}</span>
          ),
        align: "center",
      },
      {
        key: "dateDownloaded",
        name: <span className="text-color-dark-grey">{this.props.t("DOWNLOAD_DATE")}</span>,
        renderCell: ({ row }: { row: MiLogs }) =>
          row.downloadedAt ? formatDateTime(row.downloadedAt) : null,
        align: "right",
      },
    ];
  }

  handleToggleLog = () => {
    this.props.toggleMiLogModal(null);
  };

  render() {
    return (
      <Modal className="min-modal-width">
        <ModalHeader toggle={this.handleToggleLog} className="d-flex justify-content-between">
          {this.props.t("PRESENTATION_LOG")}
        </ModalHeader>
        <ModalBody className="limited-height">
          <GSGrid columns={this.columns} rows={this.props.logs} />
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.handleToggleLog}>
            {this.props.t("CANCEL")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default localize()(MiLogModal);
